<div class="gbm-last-five-operation">
  <div class="row">
    <div class="box subcontainer">
      <div class="row middle-xs">
        <div class="widget-title">{{ headerName }}</div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
            <th>Fecha</th>
            <th class="right">Hora</th>
            <th class="right">Folio</th>
            <th class="right">Monto</th>
          </thead>
          <tbody *ngIf="!showSkeleton">
            <tr *ngFor="let deposit of deposits">
              <td>{{ getFormatDate(deposit.processDate) }}</td>
              <td class="right">{{ getFormatTime(deposit.processDate) }}</td>
              <td class="right">{{ deposit.orderId }}</td>
              <td class="right">
                {{ deposit.amount | hbCustomFormat: '$0,0.00' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="showSkeleton">
            <tr *ngFor="let number of [0, 1, 2, 3, 4]">
              <td class="right"><span class="skeleton"></span></td>
              <td class="right"><span class="skeleton"></span></td>
              <td class="right"><span class="skeleton"></span></td>
              <td class="right"><span class="skeleton"></span></td>
            </tr>
          </tbody>
        </table>
        <div class="none-rows" *ngIf="totalRows <= 0 && !showSkeleton">
          <i class="icon icon-atm-icn-ordenes"></i>
          <div>No se han encontrado movimientos de efectivo.</div>
        </div>
      </div>
    </div>
  </div>
</div>
